import React from 'react'

export const EvianRules = () => {
  return (
    <div>EvianRules</div>
  )
}